
define(
    'Tavano.TavanoteamGA4.TTGA4.MyAccount'
    , [
        'Tavano.TavanoteamGA4.TTGA4.Utils'
        , 'AjaxRequestsKiller'
        , 'Backbone'
    ]
    , function (
        TTGA4Utils
        , AjaxRequestsKiller
        , Backbone
    ) {
        'use strict';
        return {
            loadGA4MyAccount: function loadGA4MyAccount(container) {
                this.trackPageGA4(container);
                var self = this;
                this.app = TTGA4Utils.getApplication('MyAccount');
                var cart = container.getComponent("Cart");
                container.getLayout().on('afterAppendView', function () {
                    var curView = container.getLayout().getCurrentView()
                        , timeout = null;
                    //,   itemsSearcher = container.getLayout().getChildViewInstance('Header').getChildViewInstance('SiteSearch').getChildViewInstance('ItemsSeacher') ? container.getLayout().getChildViewInstance('Header').getChildViewInstance('SiteSearch').getChildViewInstance('ItemsSeacher') : {};
                    var itemsSearcher = {};
                    var miniCart = container.getLayout().getChildViewInstance('Header').getChildViewInstance('Header.MiniCart');
                    if (miniCart) {
                        cart.getLines().then(function (lines) {
                            if (lines.length > 0) {
                                cart.getPromotions().then(function (promotions) {
                                    cart.getSummary().then(function (summary) {
                                        self.trackCheckout(container, 'minicart', lines, promotions, summary);
                                    });
                                });
                            }
                        });
                    }
                    if (container.getLayout().getChildViewInstance('Header').getChildViewInstance('SiteSearch')) {
                        itemsSearcher = container.getLayout().getChildViewInstance('Header').getChildViewInstance('SiteSearch').getChildViewInstance('ItemsSeacher');
                    }
                    //to ensure that previous events listeners are removed
                    //this is to avoid multiple triggers of the same event
                    //Start
                    if (Object.keys(itemsSearcher).length > 0 && itemsSearcher.$searchElement) {
                        itemsSearcher.$searchElement.off('keyup')
                        itemsSearcher.$searchElement.on('keyup', function (event) {
                            var searchQuery = jQuery(event.currentTarget).val();
                            clearTimeout(timeout);
                            timeout = setTimeout(function () {
                                if (searchQuery.trim().length >= itemsSearcher.options.minLength) {
                                    var resultCollection = itemsSearcher.collection
                                        , sort = itemsSearcher.options.sort
                                        , limit = itemsSearcher.options.limit
                                        , ajaxKiller = AjaxRequestsKiller.AjaxRequestsKiller ? AjaxRequestsKiller.AjaxRequestsKiller : AjaxRequestsKiller;
                                    resultCollection.fetch({
                                        data: {
                                            q: String(searchQuery).trim()
                                            , sort: sort
                                            , limit: limit
                                            , offset: 0
                                        }
                                        , killerId: ajaxKiller.getKillerId()
                                    },
                                        {
                                            silent: true
                                        })
                                        .done(function (searchResult) {
                                            if (searchResult.items.length > 0) {
                                                //console.log("here")
                                                TTGA4Utils.trackSearchGA4(searchQuery.trim(), 'Search Suggestion', self.app);
                                            }
                                        })
                                }
                            }, 500)
                        });
                    }
                    //end
                    if (curView.currentStep && curView.currentStep.step_url == "request-a-quote-confirmation") {
                        self.trackGenerateLead(container);
                    }
                })
            }
            , trackPageGA4: function (container) {
                container.getLayout().on('beforeAppendView', function () {
                    var curUrl = Backbone.history.fragment ? '/' + Backbone.history.fragment : '/';
                    TTGA4Utils.trackPageViewGA4(curUrl, container);
                })
            }
            , trackGenerateLead: function (container) {
                var self = this
                    , model = container.getLayout().getCurrentView().wizard.model
                    , quoteId = model.get('confirmation').get('tranid') || model.get('confirmation').get('confirmationnumber') || '';
                if (model) {
                    var eventData = this.getQuoteItems(model);
                    eventData['quote_id'] = quoteId;
                    TTGA4Utils.trackGenerateLead(eventData, container);
                }
            }
            , getQuoteItems: function (model) {
                if (Object.keys(model).length > 0) {
                    var quoteItemsObj = {}
                        , quoteItemsArr = []
                        , lines = model.get('lines') || []
                        , quoteSummary = model.get('summary') || {}
                        , self = this;
                    _.each(lines.models, function (line) {
                        var itemVariant = self.getItemOptions(line, false)
                            , itemObj = {
                                item_id: line.get('item').get('itemid')
                                , item_name: line.get('item').get('displayname') || line.get('item').get('_name') || ""
                                , quantity: line.get('quantity')
                                , price: line.get('item').get('onlinecustomerprice_detail').onlinecustomerprice
                            };
                        if (itemVariant.length > 0) {
                            itemObj['item_variant'] = itemVariant.join(',')
                        }
                        quoteItemsArr.push(itemObj);
                    });
                    quoteItemsObj.currency = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';
                    quoteItemsObj.value = quoteSummary.total;
                    quoteItemsObj.items = quoteItemsArr;
                    return quoteItemsObj;
                }
            }
            , getItemOptions: function (item, minicart) {
                var variantsArr = [];
                var itemOptionsModel = [];
                if (minicart) {
                    itemOptionsModel = item.options || [];
                } else {
                    var itemOptions = item.get('options') || [];
                    itemOptionsModel = itemOptions.models || [];
                }
                _.each(itemOptionsModel, function (option) {
                    var optionsValue;
                    if (minicart) {
                        optionsValue = option.value || {};
                    } else {
                        optionsValue = option.get('value') || {};
                    }
                    if (Object.keys(optionsValue).length > 0) {
                        variantsArr.push(optionsValue.label);
                    }
                });
                return variantsArr;
            }
            , trackCheckout: function (container, cartview, lines, promotions, summary) {
                var cartInstance = cartview == 'minicart' ? container.getLayout().getChildViewInstance('Header').getChildViewInstance('Header.MiniCart') : container.getLayout().getCurrentView();
                var checkoutBtn = cartInstance.$el.find('[data-touchpoint="checkout"]');
                var cartModel = cartInstance.model;
                var promocodes = cartview == 'minicart' ? promotions : this.getPromotions(cartModel);
                var eventData = cartview == 'minicart' ? this.getCartItems(lines, 'trackCheckout', promocodes, summary, true) : this.getCartItems(cartModel, 'trackCheckout', promocodes, summary, false);
                if (promocodes.length > 0) {
                    eventData['coupon'] = promocodes.join(',');
                }
                if (cartview == 'minicart' && cartInstance.events) {
                    if (checkoutBtn.length > 0) {
                        jQuery(checkoutBtn).off('click');
                        jQuery(checkoutBtn).on('click', function () {
                            TTGA4Utils.trackBeginCheckoutGA4(eventData, container);
                            //console.log("dataLayer begin TT_proceed_to_checkout MyAccount", JSON.stringify(window.dataLayer))
                        })
                    }
                    else {
                        var eventsObj = _.extend({}, cartInstance.events, {
                            'click [data-touchpoint="checkout"]': 'trackTTCheckout'
                        });
                        Object.defineProperty(cartInstance, 'events', {
                            get: function () {
                                return eventsObj;
                            }
                            , set: function () {
                                return eventsObj;
                            }
                            , configurable: true
                        })
                        cartInstance.trackTTCheckout = _.wrap(cartInstance['trackEvent'], function (fn) {
                            fn.apply(this, arguments) + TTGA4Utils.trackBeginCheckoutGA4(eventData, container);
                            //console.log("dataLayer TT_proceed_to_checkout MyAccount event", JSON.stringify(window.dataLayer));
                        })
                    }
                }
                else {
                    if (checkoutBtn.length > 0) {
                        jQuery(checkoutBtn).on('click', function () {
                            TTGA4Utils.trackBeginCheckoutGA4(eventData, container);
                            //console.log("dataLayer MyAccount TT_proceed_to_checkout", JSON.stringify(window.dataLayer))
                        })
                    }
                }
               // console.log("checkoutBtn MyAccount", checkoutBtn);
            }
            , getPromotions: function (model) {
                var promocodes = model.get('promocodes') || []
                    , codes = [];
                _.each(promocodes, function (val) {
                    codes.push(val.code);
                });
                return codes;
            }
            , getCartItems: function (model, stage, promotions, summary, minicart) {
                var cartItemsObj = {};
                var itemsArr = [];
                var promocodes = [];
                var lines = [];
                var self = this;
                var currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';
                if (stage == 'trackCheckout' && minicart) {
                    promocodes = promotions;
                } else {
                    promocodes = this.getPromotions(model);
                }
                if (minicart) {
                    lines = model;
                    _.each(lines, function (item) {
                        var itemName = "";
                        //Use parent item name for matrix items
                        if (item.item.extras.matrix_parent) {
                            itemName = item.item.extras.matrix_parent.storedisplayname2;
                        } else {
                            itemName = item.item.extras.storedisplayname2 || item.item.extras.displayname || item.item.extras._name;
                        }
                        var itemVariant = self.getItemOptions(item, true)
                            , itemsObj = {
                                item_id: item.item.itemid + ""
                                , item_name: itemName
                                , quantity: item.quantity
                                , currency: currencyCode
                                , price: item.item.extras.onlinecustomerprice_detail.onlinecustomerprice
                            };
                        if (promocodes.length > 0) {
                            itemsObj['coupon'] = promocodes.join(',');
                        }
                        if (itemVariant.length > 0) {
                            itemsObj['item_variant'] = itemVariant.join(',')
                        }
                        itemsArr.push(itemsObj);
                    });
                } else {
                    lines = model.get('lines');
                    _.each(lines.models, function (line) {
                        var itemName = "";
                        //Use parent item name for matrix items
                        if (line.get('item').get('matrix_parent')) {
                            itemName = line.get('item').get('matrix_parent').storedisplayname2 || line.get('item').get('matrix_parent').get('storedisplayname2');
                        } else {
                            itemName = line.get('item').get('storedisplayname2') || line.get('item').get('displayname') || line.get('item').get('_name');
                        }
                        var itemVariant = self.getItemOptions(line, false)
                            , itemsObj = {
                                item_id: line.get('item').get('itemid') + ""
                                , item_name: itemName
                                , quantity: line.get('quantity')
                                , currency: currencyCode
                                , price: line.get('item').get('onlinecustomerprice_detail').onlinecustomerprice
                            };
                        if (promocodes.length > 0) {
                            itemsObj['coupon'] = promocodes.join(',');
                        }
                        if (itemVariant.length > 0) {
                            itemsObj['item_variant'] = itemVariant.join(',')
                        }
                        itemsArr.push(itemsObj);
                    });
                }
                cartItemsObj.currency = currencyCode;
                if (summary) {
                    cartItemsObj.value = summary.total;
                } else if (model.get('summary')) {
                    cartItemsObj.value = model.get('summary').total;
                }
                if (stage == 'trackCheckout') {
                    cartItemsObj.items_checkout = itemsArr;
                } else {
                    cartItemsObj.items = itemsArr;
                }
                return cartItemsObj;
            }
        };
    });
